import { createRouter, createWebHistory } from 'vue-router';
import Entrance from '@/components/LayoutLogin';
import Main from '@/components/LayoutMain';

import NotFound from '@/views/NotFound';
import Login from '@/views/Login.vue';
import PasswordReissue from '@/views/PasswordReissue';
import PasswordSetting from '@/views/PasswordSetting';
import UseridReissue from '@/views/UseridReissue';
import BillingsList from '@/views/BillingsList.vue';
import OpeningsList from '@/views/OpeningsList.vue';
import PasswordEdit from '@/views/PasswordEdit.vue';
import AccountsList from '@/views/AccountsList.vue';
import EmergencyContactsList from '@/views/EmergencyContactsList.vue';
import BillingContactsList from '@/views/BillingContactsList.vue';
import InvoicesList from '@/views/InvoicesList.vue';
import Createform from '@/views/Createform.vue';
import ManualsList from '@/views/ManualsList.vue';

import Api from '@/constants/api';
import UserRole from '@/constants/userrole';

const routes = [
  {
    path: '/',
    component: Entrance,
    children: [
      {
        path: '/login',
        name: 'Login',
        component: Login,
        props: true,
      },
      {
        path: '/password/reissue',
        name: 'PasswordReissue',
        component: PasswordReissue,
      },
      {
        path: '/userid/reissue',
        name: 'UseridReissue',
        component: UseridReissue,
      },
      {
        path: '/mypage/:hash',
        name: 'PasswordSetting',
        component: PasswordSetting,
        props: true,
      },
      {
        path: '/reg',
        name: 'Createform',
        component: Createform,
      },
      {
        name: 'NotFound',
        path: '/:pathMatch(.*)*',
        component: NotFound,
      },
    ],
  },
  {
    path: '/',
    component: Main,
    children: [
      {
        path: '/billings/list',
        name: 'BillingsList',
        component: BillingsList,
        meta: { requiresAuth: true, accessibleUserRoles: [UserRole.ADMIN, UserRole.MANAGER, UserRole.USER] },
        props: true,
      },
      {
        path: '/openings/list/:billingProfileId',
        name: 'OpeningsList',
        component: OpeningsList,
        props: true,
        meta: { requiresAuth: true, accessibleUserRoles: [UserRole.ADMIN, UserRole.MANAGER, UserRole.USER] },
      },
      {
        path: '/password/edit',
        name: 'PasswordEdit',
        component: PasswordEdit,
        meta: { requiresAuth: true, accessibleUserRoles: [UserRole.ADMIN, UserRole.MANAGER, UserRole.USER, UserRole.BILLINGUSER] },
      },
      {
        path: '/accounts/list',
        name: 'AccountsList',
        component: AccountsList,
        meta: { requiresAuth: true, accessibleUserRoles: [UserRole.ADMIN, UserRole.MANAGER, UserRole.USER] },
      },
      {
        path: '/emergency_contacts/list',
        name: 'EmergencyContactsList',
        component: EmergencyContactsList,
        meta: { requiresAuth: true, accessibleUserRoles: [UserRole.ADMIN, UserRole.MANAGER, UserRole.USER] },
      },
      {
        path: '/billings/contacts/list',
        name: 'BillingContactsList',
        component: BillingContactsList,
        meta: { requiresAuth: true, accessibleUserRoles: [UserRole.ADMIN, UserRole.MANAGER, UserRole.USER] },
      },
      {
        path: '/invoices/list',
        name: 'InvoicesList',
        component: InvoicesList,
        meta: { requiresAuth: true, accessibleUserRoles: [UserRole.ADMIN, UserRole.MANAGER, UserRole.USER, UserRole.BILLINGUSER] },
        props: true,
      },
      {
        path: '/manuals/list',
        name: 'ManualsList',
        component: ManualsList,
        meta: { requiresAuth: true, accessibleUserRoles: [UserRole.ADMIN, UserRole.MANAGER, UserRole.USER, UserRole.BILLINGUSER] },
      },
    ],
  },
];

const fetchSession = async function (token) {
  const ret = {};
  ret.isLogin = false;
  if (!token) {
    return ret;
  }
  const { $axios } = router.app.config.globalProperties;
  await $axios
    .get(Api.PATH_SESSION)
    .then((response) => {
      if (response.data.status == Api.STATUS_SUCCESS) {
        ret.isLogin = true;
        ret.roleId = response.data.session.role_id;
      }
    })
    .catch((reason) => console.log(reason));
  return ret;
};

const patchSession = async function (token) {
  if (!token) {
    return;
  }
  const { $axios } = router.app.config.globalProperties;
  await $axios
    .patch(Api.PATH_SESSION + Api.PATH_EXPIRE)
    .then((response) => {
      if (response.data.status != Api.STATUS_SUCCESS) {
        console.log(response);
      }
    })
    .catch((reason) => console.log(reason));
};

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach(async function (to, from, next) {
  const { $cookies } = router.app.config.globalProperties;
  var session = await fetchSession($cookies.get('access_token'));
  patchSession($cookies.get('access_token'));
  console.log('to.matched', to.matched);
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (session.isLogin) {
      if (
        !to.matched
          .filter((record) => typeof record.meta.accessibleUserRoles !== 'undefined')
          .some((record) => record.meta.accessibleUserRoles.includes(session.roleId))
      ) {
        if (session.roleId === UserRole.BILLINGUSER) {
          next({ name: 'InvoicesList' });
        } else {
          next();
        }
      } else {
        next();
      }
    } else {
      next({ name: 'Login' });
    }
  } else {
    if (to.path == '/') {
      if (session.isLogin) {
        next({ name: 'BillingsList' });
      } else {
        next({ name: 'Login' });
      }
    } else {
      next();
    }
  }
});

export default router;
